<template>
  <div
    class="dui-scroll-available"
    :class="{ 'enabled': isEnabled }"
  >
    <DuiIconDown
      v-if="isEnabled"
      class="icon-sm icon-white"
    />
  </div>
</template>

<script>
import ResizeObserver from 'resize-observer-polyfill';

function _shouldEnableScroll(refEl) {
  if (refEl === document.body) {
    return document.body.scrollHeight > document.body.clientHeight;
  }

  return refEl.scrollHeight > refEl.parentElement.clientHeight;
}

export default {
  props: {
    refElementId: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    isEnabled: false,
    refEl: document.body,
    resizeObserver: null,
    wasManuallyDisabled: false,
  }),
  beforeDestroy() {
    this.removeEventListeners();
    this.removeResizeObserver();
  },
  mounted() {
    this.setRefElement();
    this.setup();
    this.createResizeObserver();
  },
  methods: {
    addEventListeners() {
      this.refEl.addEventListener('scroll', this.scrollPerformed);
    },

    createResizeObserver() {
      this.resizeObserver = new ResizeObserver(this.resizeTriggered);
      this.resizeObserver.observe(this.refEl);
    },

    enable() {
      this.addEventListeners();
      this.$set(this, 'isEnabled', true);
    },

    disable() {
      this.removeEventListeners();
      this.$set(this, 'isEnabled', false);
    },

    removeEventListeners() {
      this.refEl.removeEventListener('scroll', this.scrollPerformed);
    },

    removeResizeObserver() {
      if (!this.resizeObserver) {
        return;
      }

      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    },

    resizeTriggered() {
      this.setup();
    },

    scrollPerformed() {
      // Ignore programatical reset
      if (this.refEl.scrollTop === 0) {
        return;
      }

      this.$set(this, 'wasManuallyDisabled', true);
      this.disable();
      this.removeResizeObserver();
    },

    setRefElement() {
      let refEl;

      if (!this.refElementId || !(refEl = document.getElementById(this.refElementId))) {
        return;
      }

      this.$set(this, 'refEl', refEl);
    },

    setup() {
      if (!_shouldEnableScroll(this.refEl)) {
        this.disable();
        return;
      }

      if (this.wasManuallyDisabled) {
        return;
      }

      this.enable();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translate3d(-50%, 0, 0);
  }
  40% {
    transform: translate3d(-50%, -20%, 0);
  }
  60% {
    transform: translate3d(-50%, -15%, 0);
  }
}

.dui-scroll-available {
  background: getColor($black);
  border-radius: $border-radius-xl;
  bottom: 0;
  box-shadow: $box-shadow-base;
  display: inline-block;
  height: $_2-5em;
  left: 50%;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  width: $_5em;
  z-index: 2;

  @include transition((
    opacity
  ));

  &.enabled {
    animation: bounce 2s infinite;
    opacity: 1;
  }

  .dui-icon {
    left: 50%;
    position: absolute;
    top: $_0-5em;
    transform: translateX(-50%);
    z-index: 1;
  }
}
</style>
